<template lang="pug">
    vue-resize-sensor(@resize="resize")
</template>

<script>
import VueResizeSensor from 'vue-resize-sensor'
import EventBus from '../lib/event-bus'

const MIN_CROSS_INTERVAL = 100
const MAX_CROSS_INTERVAL = 3000
const DISABLE_CROSS_EVENT = 'disable-resize-sensor-cross-browser-compatibility'

export default {
    name: 'resize-sensor',

    components: {
        VueResizeSensor,
    },

    data() {
        return {
            disableCross: false,
            interval: MIN_CROSS_INTERVAL,
            lastSize: {},
        }
    },

    methods: {
        resize(e) {
            if (!this.disableCross && (e.width || e.height)) {
                EventBus.$emit(DISABLE_CROSS_EVENT)
            }
            this.emitResize(e)
        },

        resizeCross() {
            if (this.disableCross) {
                return
            }

            const el = this.$el
            const size = {
                width: el.offsetWidth,
                height: el.offsetHeight,
            }

            if (size.width || size.height) {
                this.emitResize(size)
            }

            if (size.width != this.lastSize.width || size.height != this.lastSize.height) {
                this.interval = MIN_CROSS_INTERVAL
            }
            else {
                this.interval *= 2
                if (this.interval > MAX_CROSS_INTERVAL) {
                    this.interval = MAX_CROSS_INTERVAL
                }
            }

            this.lastSize = size

            setTimeout(this.resizeCross, this.interval)
        },

        emitResize(e) {
            this.$emit('resize', e)
        },
    },

    mounted() {
        setTimeout(this.resizeCross, 5)
    },

    created() {
        EventBus.$on(DISABLE_CROSS_EVENT, () => {
            this.disableCross = true
        })
    },
}
</script>
